import script from "./UploadConfirmation.vue?vue&type=script&lang=ts&setup=true"
export * from "./UploadConfirmation.vue?vue&type=script&lang=ts&setup=true"

import "./UploadConfirmation.vue?vue&type=style&index=0&id=3425111a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3425111a"]])

export default __exports__